'use client';

import { createContext } from 'react';

import type { BannerRootContextInterface } from '../types/banner-root.types';

export const BannerRootContext = createContext<BannerRootContextInterface>({
  closeBanner: () => {},
});

BannerRootContext.displayName = 'Banner.Root.Context';
